module.exports = __webpack_public_path__ + "static/media/Thapelo.791b7e0e.jpg";